import { FC, useCallback } from 'react';
import ApplicationsContainer from '../../../applications/containers/ApplicationsContainer';
import ApplicationsLoader from '../../../applications/containers/ApplicationsLoader';
import { AppPages, navigate } from '../../../common/routing/app-navigator';
import FixedPage from '../FixedPage';

const ApplicationsPage: FC<React.PropsWithChildren<unknown>> = () => {
  const navigateToConnectorsPage = useCallback(() => {
    navigate(AppPages.Connectors);
  }, []);

  return (
    <FixedPage>
      <ApplicationsLoader navigateToConnectorsPage={navigateToConnectorsPage}>
        <ApplicationsContainer />
      </ApplicationsLoader>
    </FixedPage>
  );
};

export default ApplicationsPage;
